<app-loader *ngIf="isLoading"></app-loader>

<div class="main-container lg-view">
    <h3> Procedure Form Validations Skip Request </h3>
    <h5> by {{jobProcedureFormValidationsSkipRequestDetails.requestDetails.requestedBy}} on  {{ jobProcedureFormValidationsSkipRequestDetails.requestedOn | date:'MM/dd/yyyy hh:mm a':'UTC' }}
    </h5>

    <h3 *ngIf="jobProcedureFormValidationsSkipRequestDetails.isRequestCompleted">
        <span *ngIf="jobProcedureFormValidationsSkipRequestDetails.isApproved" class="text-green">APPROVED</span>
        <span *ngIf="!jobProcedureFormValidationsSkipRequestDetails.isApproved" class="text-red">REJECTED</span>
    </h3>
    <h5 *ngIf="jobProcedureFormValidationsSkipRequestDetails.isRequestCompleted">
        by {{jobProcedureFormValidationsSkipRequestDetails.requestDetails.completedBy}}
    </h5>
    <p *ngIf="!jobProcedureFormValidationsSkipRequestDetails.isApproved && jobProcedureFormValidationsSkipRequestDetails.comment">
        Comment : {{jobProcedureFormValidationsSkipRequestDetails.comment}}
    </p>

    <h4> Please find below more details about the request :</h4>

    <ng-container
            *ngTemplateOutlet="jobProcedureFormValidationsSkipRequestDetails.requestDetails.siteName ? infoTemplate : null; context: { label: 'Site', text: jobProcedureFormValidationsSkipRequestDetails.requestDetails.siteName }">
    </ng-container>

    <ng-container
            *ngTemplateOutlet="jobProcedureFormValidationsSkipRequestDetails.requestDetails.assetName ? infoTemplate : null; context: { label: 'Asset', text: jobProcedureFormValidationsSkipRequestDetails.requestDetails.assetName }">
    </ng-container>

    <ng-container
            *ngTemplateOutlet="jobProcedureFormValidationsSkipRequestDetails.requestDetails.procedureName ? infoTemplate : null; context: { label: 'Procedure', text: jobProcedureFormValidationsSkipRequestDetails.requestDetails.procedureName }">
    </ng-container>

    <ng-container
            *ngTemplateOutlet="jobProcedureFormValidationsSkipRequestDetails.requestDetails.formName ? infoTemplate : null; context: { label: 'Form', text: formattedFormName }">
    </ng-container>

    <ng-container
            *ngTemplateOutlet="jobProcedureFormValidationsSkipRequestDetails.skipReason ? infoTemplate : null; context: { label: 'Reason', text: jobProcedureFormValidationsSkipRequestDetails.skipReason }">
    </ng-container>

    <generic-modal #procedureFormValidationsSkipResponseModal>
        <ng-template #modalHeading>
            <h3 style="text-align: center; font-weight: 100">The procedure form validations skip request</h3>
        </ng-template>

        <ng-template #modalBody>
            <div style="text-align: center;">
                <h4 style="margin-top: 0;">was successfully approved</h4>
            </div>
        </ng-template>

        <ng-template #modalActions>
            <button mat-raised-button class="secondary" type="button" (click)="closeProcedureFormValidationsSkipResponseModal()">Ok</button>
        </ng-template>
    </generic-modal>

    <generic-modal #procedureFormValidationsSkipResponseModalError>
        <ng-template #modalHeading>
            <h3 style="text-align: center; font-weight: 100">The procedure form validations skip request could not be processed</h3>
        </ng-template>

        <ng-template #modalActions>
            <button mat-raised-button class="secondary" type="button" (click)="closeProcedureFormValidationsSkipResponseModal()">Ok</button>
        </ng-template>
    </generic-modal>

</div>

<action-button-carousel *ngIf="!jobProcedureFormValidationsSkipRequestDetails.isRequestCompleted">
    <ng-template #buttonsTemplate>
        <action-button [clickAction]="submitApprove.bind(self)" @slideUp @fadeIn [icon]="ButtonIcons.StatusChange"
                       [name]="'Approve'"></action-button>

        <action-button [clickAction]="navigateWithData.bind(self, 'reject')" @slideUp @fadeIn [icon]="ButtonIcons.Delete"
                       [name]="'Reject'"></action-button>
    </ng-template>
</action-button-carousel>

<ng-template #infoTemplate let-label="label" let-text="text">
    <div class="job-details">
        <div class="job-details-text">
            <span class="label">{{ label }}</span>
            <span *ngIf="text">{{ text }}</span>
        </div>
    </div>
</ng-template>
